import React from 'react';
import {
	MimaButton,
	MimaDropdown,
	MimaInput,
	MimaText,
	NewModal,
} from '../../components';
import { useCreatePlanModal } from './logic';

const CreatePlanModal = ({ closeModal, currentPlan }) => {
	const { formik, intervals, getCycleLabel, currencyOptions } =
		useCreatePlanModal({
			closeModal,
			currentPlan,
		});

	const {
		values,
		touched,
		handleBlur,
		errors,
		handleChange,
		handleSubmit,
		isSubmitting,
		setFieldValue,
	} = formik;

	return (
		<NewModal closeModal={closeModal}>
			<form onSubmit={handleSubmit}>
				<MimaText align="center" variant="subtitleBold">
					{currentPlan?._id ? 'Edit Plan' : 'Create a Plan'}
				</MimaText>
				<MimaInput
					labelTitle="Plan name"
					placeholder="Enter a plan name"
					name="name"
					value={values.name}
					onChange={handleChange}
					onBlur={handleBlur}
					touched={touched.name}
					error={errors.name}
				/>

				<MimaDropdown
					labelTitle="Select Intervals"
					name="interval"
					value={values.interval}
					placeholder={'Select interval'}
					id="interval"
					currentValue={values.interval}
					onChange={data => {
						setFieldValue('interval', data.key);
					}}
					data={intervals}
					touched={touched.interval}
					error={errors.interval}
				/>

				<MimaInput
					labelTitle="Cycle(s)"
					placeholder="Enter Cycle"
					name="cycle"
					value={values.cycle}
					onChange={handleChange}
					onBlur={handleBlur}
					touched={touched.cycle}
					error={errors.cycle}
					note={getCycleLabel(values.interval)}
					type="number"
				/>

				<MimaDropdown
					labelTitle="Currency"
					name="currencyCode"
					value={values.currencyCode}
					placeholder="Select Currency"
					id="currencyCode"
					currentValue={values.currencyCode}
					onChange={data => {
						setFieldValue('currencyCode', data.key);
					}}
					data={currencyOptions}
					touched={touched.currencyCode}
					error={errors.currencyCode}
				/>

				<MimaInput
					labelTitle="Amount"
					placeholder="Enter Amount"
					name="amount"
					value={values.amount}
					onChange={handleChange}
					onBlur={handleBlur}
					touched={touched.amount}
					error={errors.amount}
					note={'Amount per Debit'}
					type="number"
				/>
				<MimaInput
					labelTitle="Trial Period in Days"
					placeholder="Enter Trial Period"
					name="trialPeriod"
					value={values.trialPeriod}
					onChange={handleChange}
					onBlur={handleBlur}
					touched={touched.trialPeriod}
					error={errors.trialPeriod}
					note={'Leave as 0 if not free trial period'}
					type="number"
				/>

				<MimaInput
					labelTitle="Activation Webhook"
					placeholder="Enter plan activation webhook url"
					name="activateUrl"
					value={values.activateUrl}
					onChange={handleChange}
					onBlur={handleBlur}
					touched={touched.activateUrl}
					error={errors.activateUrl}
					note={'Leave empty if you do not have a webhook'}
				/>
				<MimaInput
					labelTitle="Deactivation Webhook"
					placeholder="Enter a plan deactivation webhook url"
					name="deActivateUrl"
					value={values.deActivateUrl}
					onChange={handleChange}
					onBlur={handleBlur}
					touched={touched.deActivateUrl}
					error={errors.deActivateUrl}
					note={'Leave empty if you do not have a webhook'}
				/>

				<MimaButton
					title={currentPlan?._id ? 'Update Plan' : 'Create Plan'}
					type="submit"
					onClick={handleSubmit}
					mt={2}
					width={38}
					buttonColor="var(--color-primary)"
					variant="filter"
					loading={isSubmitting}
				/>
			</form>
		</NewModal>
	);
};

export default CreatePlanModal;
